import { Facade, vservice } from '@niknevis/vue-modules'
import { NotificationModel, NotificationModelType } from '@/modules/notification/models/notification.model'
import { Paginated } from '@/modules/shared/models/data'
import { NotificationApiRoute } from '@/modules/notification/routes/panelNotificationRoute'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { Paginatable } from '@/modules/shared/helpers/http/paginatable'

@vservice()
export class NotificationService {
  constructor(
    private readonly apiRoute: NotificationApiRoute
  ) {
  }

  getList(): RemoteData<NotificationModelType> {
    return RemoteData.fromPromise(
      HTTP.get(
        this.apiRoute.bell()
      ).then(result => result.json())
    )
  }

  getAll(options = {}): RemoteData<Paginated<NotificationModel[]>> {
    return RemoteData.fromPromise(
      HTTP.get(
        this.apiRoute.all(),
        {
          //searchParams: collect(options).filter().all() as any
        }
      ).then(result => result.json())
    )
  }

  getAllPaginatable() {
    return new Paginatable(
      (page) =>
        this.getAll({
          page
        }),
      (oldValue, newValue) => {
        newValue.data = oldValue.data.concat(newValue.data)
        return newValue
      }
    )
  }

  markAllAsRead() {
    return HTTP.get(
      this.apiRoute.markAllAsRead()
    ).then(result => result.json())
  }

}

export class Notification extends Facade<NotificationService>() {
  static getFacadeAccessor() {
    return NotificationService
  }
}
